import { useEffect, useRef, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { autoCompleteDelay } from "../../config";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, DropDownData, FetchAutoCompleteData, FileUploadChild, FindTranslatedKey, convertThreeDecimalsOnValue, convertToNumber, convertTwoDecimalsOnValue, handleDateChange } from "../CommonComponents/CustomHooks";
import { AutoCompleteBox, DateBox, FormButton, InputBox, SelectInputBox } from "../CommonComponents/InputBox";
import { GetSession } from "../../EnvConfig/env_config";
import { FaRegEye } from "react-icons/fa";
import Modal from 'react-bootstrap/Modal';
import { IoAddCircleSharp } from "react-icons/io5";
import { RiAddBoxFill } from "react-icons/ri";
import { GrPowerReset } from "react-icons/gr";
const PickUpRequest = ({ menuText }) => {
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const awbNo = searchParams.get('AwbNo');
    const PageType = searchParams.get('PageType');
    const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
    const [remainingClicks, setRemainingClicks] = useState(0);
    const [remainingDescClicks, setRemainingDescClicks] = useState(0);
    const Branchcode = GetSession('cookies', 'branchCode');
    const [incomeModalShow, setincomeModalShow] = useState(false)
    const [identicalShow, setidenticalShow] = useState(false)
    const [invoicePrint, setInvoicePrint] = useState(false)
    const [refValue, setRefValue] = useState('');
    const Hidesfield = false
    const bcode = Branchcode?.split(" : ")[0] || '';
    const selectedDate2 = new Date();
    const dateArr2 = selectedDate2.toDateString().split(" ");
    const formattedDate1 = `${dateArr2[2]}-${dateArr2[1]}-${dateArr2[3]}`;
    const handleModalShowClose = () => setincomeModalShow(false);

    const handleOpen = async (key) => {
        await setincomeModalShow(true)
    };

    const handleModalIdenticalShowClose = () => setidenticalShow(false);

    const handleOpenIdentical = async (key) => {
        await setidenticalShow(true)
    };


    const [formData, setFormData] = useState({
        "pickupID": '',
        "awbNo": '',
        "custReferenceNo": '',
        "referenceNumber": '',
        "shipmentDate": formattedDate1,
        "cCode": '',
        "branchCode": Branchcode,
        "imageName": '',
        "imageExt": '',
        "imagebase64": '',
        "autoAwbNo": true,

        "consignorCode": '',
        "consignorName": '',
        "consignorAddress1": '',
        "consignorAddress2": '',
        "consignorAddress3": '',
        "consignorCityCode": '',
        "consignorStateCode": '',
        "consignorCountryCode": '',
        "consignorZipCode": '',
        "consignorPhoneNo": '',
        "consignorEmailID": '',
        "consignorGSTIN": '',
        "consignorAddressBook": false,

        "consigneeCode": '',
        "consigneeName": '',
        "consigneeCPerson": '',
        "consigneeAddress1": '',
        "consigneeAddress2": '',
        "consigneeAddress3": '',
        "consigneeCityCode": '',
        "consigneeStateCode": '',
        "consigneeCountryCode": '',
        "consigneeZipCode": '',
        "consigneePhoneNo": '',
        "consigneeEmailID": '',
        "consigneeGSTIN": '',
        "consigneeAddressBook": false,

        "totalPacket": '',
        "totalValue": '',
        "currencyName": '',
        "actualWeight": '',
        "weightUnit": '',
        "volumetricWeight": '',
        "chargedWeight": '',
        "perKGRate": '',
        "volumetric": false,
        "divisor": '5000',
        //"weightDetails": [
        //    {
        //        "weightDetailsID": '',
        //        "length": '',
        //        "breadth": '',
        //        "height": '',
        //        "volWeight": '',
        //        "packages": '',
        //    }
        //],
        weightDetails: [],
        "packetType": '',
        "paymentType": '',
        "codAmount": '',
        "codCurrency": '',
        "descTotalValue": '',

        "descriptionDetail": [{
            "descriptionDetailsID": '',
            "description": '',
            "units": '',
            "unitValue": '',
            "hsNo": '',
            "total": '',
            "uniqueQuantity": '',
        }]
    })

    const handleClear = () => {
        setFormData({
            "pickupID": '',
            "awbNo": '',
            "custReferenceNo": '',
            "referenceNumber": '',
            "shipmentDate": formattedDate1,
            "cCode": '',
            "branchCode": Branchcode,
            "imageName": '',
            "imageExt": '',
            "imagebase64": '',
            "autoAwbNo": true,

            "consignorCode": '',
            "consignorName": '',
            "consignorAddress1": '',
            "consignorAddress2": '',
            "consignorAddress3": '',
            "consignorCityCode": '',
            "consignorStateCode": '',
            "consignorCountryCode": '',
            "consignorZipCode": '',
            "consignorPhoneNo": '',
            "consignorEmailID": '',
            "consignorGSTIN": '',
            "consignorAddressBook": false,

            "consigneeCode": '',
            "consigneeName": '',
            "consigneeCPerson": '',
            "consigneeAddress1": '',
            "consigneeAddress2": '',
            "consigneeAddress3": '',
            "consigneeCityCode": '',
            "consigneeStateCode": '',
            "consigneeCountryCode": '',
            "consigneeZipCode": '',
            "consigneePhoneNo": '',
            "consigneeEmailID": '',
            "consigneeGSTIN": '',
            "consigneeAddressBook": false,

            "totalPacket": '',

            "totalValue": '',
            "currencyName": '',
            "actualWeight": '',
            "weightUnit": '',
            "volumetricWeight": '',
            "chargedWeight": '',
            "perKGRate": '',
            "volumetric": false,
            "exportDeclarationCharge": false,
            "divisor": '5000',
            "weightDetails": [
                {
                    "weightDetailsID": '',
                    "length": '',
                    "breadth": '',
                    "height": '',
                    "volWeight": '',
                    "packages": '',
                }
            ],


            "packetType": '',
            "paymentType": '',
            "codAmount": '',
            "codCurrency": '',
            "descTotalValue": '',

            "descriptionDetail": [{
                "descriptionDetailsID": '',
                "description": '',
                "units": '',
                "unitValue": '',
                "hsNo": '',
                "total": '',
                "uniqueQuantity": '',
            }]
        });


        inputrefs.current['txtCustomerBillNo'].focus();
    };


    const [identicalForm, setIdenticalForm] = useState({
        "identicalLenght": '',
        "identicalWidht": '',
        "identicalHeight": '',
        "identicalVol": '',
        "identicalpieces": '',

    })

    const handleIdentical = () => {
        const arr = Number(identicalForm.identicalpieces);
        const totalPacket = Number(formData.totalPacket);


        if (totalPacket === 0) {
            NotificationSound('ERROR', 'Please Filled pieces!.', '', '', '');
            return;
        }
        if (arr > totalPacket) {
            NotificationSound('ERROR', 'You have selected more pieces than available!.', '', '', '');
            return;
        }
        const length = identicalForm.identicalLenght;
        const breadth = identicalForm.identicalWidht;
        const height = identicalForm.identicalHeight;
        const volWeight = identicalForm.identicalVol;
        fillInitialData(arr, length, breadth, height, volWeight);
        setidenticalShow(false);
        handleIdenticalReset()
    };


    //const fillInitialData = (arr, length, breadth, height, volWeight) => {
    //    setFormData(prevFormData => {
    //        const updatedRows = [...prevFormData.weightDetails];
    //        for (let i = 0; i < arr; i++) {

    //            if (i < updatedRows.length) {
    //                updatedRows[i] = {
    //                    ...updatedRows[i],
    //                    length: length,
    //                    breadth: breadth,
    //                    height: height,
    //                    volWeight: volWeight,
    //                };
    //            }
    //        }
    //        return {
    //            ...prevFormData,
    //            weightDetails: updatedRows,
    //        };
    //    });
    //};
    const fillInitialData = (arr, length, breadth, height, volWeight) => {
        setFormData(prevFormData => {
            const updatedRows = [...prevFormData.weightDetails];

            // Find the index of the first unfilled row
            let startIndex = updatedRows.findIndex(row => !row.length && !row.breadth && !row.height && !row.volWeight);

            // If all rows are filled, startIndex will be -1, set it to 0
            if (startIndex === -1) startIndex = 0;

            // Fill rows starting from startIndex
            for (let i = startIndex; i < startIndex + arr; i++) {
                if (i < updatedRows.length) {
                    updatedRows[i] = {
                        ...updatedRows[i],
                        length: length,
                        breadth: breadth,
                        height: height,
                        volWeight: volWeight,
                    };
                }
            }

            return {
                ...prevFormData,
                weightDetails: updatedRows,
            };
        });
    };


    const handleNewArrayAddonChange = (event) => {
        const newNumRows = event.target.value; // This will be a string
        const newNumRowsInt = parseInt(newNumRows, 10); // Convert to integer for logic

        setRemainingDescClicks(newNumRowsInt);

        // Get the existing rows from formData
        const existingRows = formData.weightDetails || [];

        // Create new rows or truncate the existing ones
        let newRows;
        if (newNumRowsInt > existingRows.length) {
            // Add new empty rows
            newRows = [
                ...existingRows,
                ...Array.from({ length: newNumRowsInt - existingRows.length }, () => ({
                    weightDetailsID: '',
                    length: '',
                    breadth: '',
                    height: '',
                    volWeight: '',
                    packages: '',
                }))
            ];
        } else {
            // Keep only the first newNumRowsInt rows
            newRows = existingRows.slice(0, newNumRowsInt);
        }

        // Update formData state
        setFormData(prevFormData => ({
            ...prevFormData,
            totalPacket: newNumRows, // Store as string
            weightDetails: newRows,  // Update with the newRows
        }));
    };


    //const handleNewArrayAddonChange = (event) => {
    //    const newNumRows = parseInt(event.target.value, 10); // Make sure the value is an integer
    //    setRemainingDescClicks(newNumRows);

    //    // Get the existing rows from formData
    //    const existingRows = formData.weightDetails || [];

    //    // Create new rows or truncate the existing ones
    //    let newRows;
    //    if (newNumRows > existingRows.length) {
    //        // Add new empty rows
    //        newRows = [
    //            ...existingRows,
    //            ...Array.from({ length: newNumRows - existingRows.length }, () => ({
    //                weightDetailsID: '',
    //                length: '',
    //                breadth: '',
    //                height: '',
    //                volWeight: '',
    //                packages: '',
    //            }))
    //        ];
    //    } else {
    //        // Keep only the first newNumRows rows
    //        newRows = existingRows.slice(0, newNumRows);
    //    }

    //    // Update formData state
    //    setFormData(prevFormData => ({
    //        ...prevFormData,
    //        totalPacket: newNumRows,
    //        weightDetails: newRows, // Update with the newRows
    //    }));
    //};


    //const handleNewArrayAddonChange = (event) => {
    //    const newNumRows = event.target.value;
    //    setRemainingDescClicks(newNumRows);
    //    setFormData({ ...formData, totalPacket: newNumRows })
    //    const newRows = Array.from({ length: newNumRows }, () => ({
    //        weightDetailsID: '',
    //        length: '',
    //        breadth: '',
    //        height: '',
    //        volWeight: '',
    //        packages: '',
    //    }));

    //    // Update formData state
    //    setFormData(prevFormData => ({
    //        ...prevFormData,
    //        weightDetails: newRows, // Replace old rows with newRows
    //    }));
    //};



    const handleDelete = (index) => {
        if (formData.weightDetails?.length <= 1) {
            return
        } else {
            let list = [...formData.weightDetails];
            list.splice(index, 1);
            setFormData({ ...formData, weightDetails: list });
        }
    };

    const HandleEditData = async (value) => {
        setSubLoading(true)
        let data = await ApiCall('/api/Operation/GetPickUpRequestData', { awbNo: value, PageType })
        let record = data.data;
        if (data.status === 'SUCCESS') {
            setFormData({ ...formData, ...record });
            setRemainingClicks(Number(record.totalPacket))
            setRemainingDescClicks(record.totalPacket)
            setInvoicePrint(true)
            setRefValue(record.awbNo)

        }
    }


    const handleAddDesc = () => {
        if (Number(formData.totalPacket) === formData?.descriptionDetail?.length) {
            NotificationSound('ERROR', `You have  Selected only ${formData.totalPacket} Pieces!.`, '', '', '');
            return
        }
        if (Number(formData.descTotalValue) < Number(formData.totalValue)) {
            if (Number(formData.totalPacket) !== formData.descriptionDetail.length) {
                let list = [...formData.descriptionDetail];
                list = [...list, {
                    "descriptionDetailsID": '',
                    "description": '',
                    "units": '',
                    "unitValue": '',
                    "hsNo": '',
                    "total": '',
                }];
                setFormData({ ...formData, descriptionDetail: list });
                setRemainingDescClicks(remainingDescClicks - 1);
            } else {
                NotificationSound('ERROR', `You have  Selected only ${formData.totalPacket} Pieces!.`, '', '', '');
            }
        } else {
            NotificationSound('ERROR', 'Desc Value should be less than total Value');
        }
    };

    const handleDeleteDesc = (index) => {
        if (formData.descriptionDetail?.length <= 1) {
            return
        } else {
            let list = [...formData.descriptionDetail];
            list.splice(index, 1);
            setFormData({ ...formData, descriptionDetail: list });
        }
    };

    const GetPaymentType = DropDownData('GetPaymentType')
    const GetPacketType = DropDownData('GetPacketType')
    const GetCurrency = DropDownData('GetCurrency')
    const GetWeightUnit = DropDownData('GetWeightUnit')
    const GetQUCType = DropDownData('GetUQC')
    const handleSubmit = async () => {
        const datavalue = {
            ...formData,
            Type: PageType
        }
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Operation/InsertUpdatePickUpRequestMaster', datavalue)
        await dispatch(setSubLoading(false))
        await setInvoicePrint(false)
        if (data.status === 'ERROR' || data.status === 'EXPIRED' || data.status === 'UNAUTHORIZED' || data.status === 'SUCCESS') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
            if (data.status === 'SUCCESS') {
                await setRefValue(data.referenceNo)
                await setInvoicePrint(true)
            }

        }
    }

    let totalVolWgt = 0;
    for (let i = 0; i < formData.weightDetails?.length; i++) {
        totalVolWgt += Number(formData.weightDetails[i].volWeight);
    }

    let descTotalValue = 0;
    for (let i = 0; i < formData.descriptionDetail?.length; i++) {
        descTotalValue += Number(formData.descriptionDetail[i].total);
    }

    const autoCompleteTimeoutRef = useRef(null);
    const handleAutoCompleteChange = async (event, newValue, field, type) => {
        if (autoCompleteTimeoutRef.current) {
            clearTimeout(autoCompleteTimeoutRef.current);
        }
        if (event?.type === 'change') {
            autoCompleteTimeoutRef.current = setTimeout(async () => {
                const autoOptions = await FetchAutoCompleteData('', newValue, type, field);
                setAutoCompleteOptions(autoOptions ? autoOptions : []);
            }, autoCompleteDelay)
        }
        setInvoicePrint(false)
    };

    const getconsignordataResquet = async (value) => {
        if (!value || value.trim() === '') {
            // Clear all fields if the value is empty
            setFormData({
                ...formData,
                consignorName: '',
                consignorAddress1: '',
                consignorAddress2: '',
                consignorCityCode: '',
                consignorStateCode: '',
                consignorCountryCode: '',
                consignorZipCode: '',
                consignorPhoneNo: '',
                consignorEmailID: '',
                consignorGSTIN: '',
            });
            return;
        }

        const code = value.split(" : ")[0];
        let data = await ApiCall('/api/Operation/GetConsignorPickupDetails', { CCode: code });
        setFormData({
            ...formData,
            consignorName: value,
            consignorAddress1: data.data.consignorAddress,
            consignorAddress2: data.data.consignorAddress1,
            consignorCityCode: data.data.consignorCity,
            consignorStateCode: data.data.consignorState,
            consignorCountryCode: data.data.consignorCountry,
            consignorZipCode: data.data.consignorPin,
            consignorPhoneNo: data.data.consignorPhone,
            consignorEmailID: data.data.consignorEmailID,
            consignorGSTIN: data.data.consigneeGSTIN,
        });
    };

    const getConsigneedataResquet = async (value) => {
        if (!value || value.trim() === '') {
            // Clear all fields if the value is empty
            setFormData({
                ...formData,
                consigneeName: '',
                consigneeAddress1: '',
                consigneeAddress2: '',
                consigneeCityCode: '',
                consigneeStateCode: '',
                consigneeCountryCode: '',
                consigneeZipCode: '',
                consigneePhoneNo: '',
                consigneeEmailID: '',
                consigneeGSTIN: '',
            });
            return;
        }

        const code = value.split(" : ")[0];
        let data = await ApiCall('/api/Operation/GetConsigneePickupDetails', { CCode: code });
        setFormData({
            ...formData,
            consigneeName: value,
            consigneeAddress1: data.data.consigneeAddress,
            consigneeAddress2: data.data.consigneeddress1,
            consigneeCityCode: data.data.consigneeCity,
            consigneeStateCode: data.data.consigneeState,
            consigneeCountryCode: data.data.consigneeCountry,
            consigneeZipCode: data.data.consigneePin,
            consigneePhoneNo: data.data.consigneePhone,
            consigneeEmailID: data.data.consigneeEmailID,
            consigneeGSTIN: data.data.consigneeGSTIN,
        });
    };
    const base64ToBlob = (base64, mime) => {
        const byteChars = atob(base64);
        const byteArrays = [];
        for (let offset = 0; offset < byteChars.length; offset += 512) {
            const slice = byteChars.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: mime });
    };

    const generatePdfUrl = (base64) => {
        const blob = base64ToBlob(base64, 'application/pdf');
        return URL.createObjectURL(blob);
    };

    const handlePrint = async (value) => {
        await dispatch(setSubLoading(true))
        let imgresult = await ApiCall('/api/Report/PickupPrint', { PickupReferenceNo: refValue });
        await dispatch(setSubLoading(false))
        let result = imgresult;
        if (result.status === 'ERROR' || result.status === 'EXPIRED') {
            await NotificationSound(result.status, result.message, result.focus, inputrefs, handleClear);
            await dispatch(setSubLoading(false))
        }
        const blob = base64ToBlob(result.documentPdfBase64?.split(',')[1], 'application/pdf');
        const url = URL.createObjectURL(blob);
        const PDFWindow = window.open("");
        PDFWindow.document.write("<iframe width='100%' height='100%' src='" + url + "'></iframe>");
    }

    const calculateVolWeight = (length, width, height,) => {
        if (!length || !width || !height) return '';
        return ((length * width * height) / Number(formData.divisor)).toFixed(3);
    };

    const handleChangeIdentical = (field, value) => {
        const updatedForm = { ...identicalForm, [field]: value };
        if (['identicalLenght', 'identicalWidht', 'identicalHeight'].includes(field)) {
            const { identicalLenght, identicalWidht, identicalHeight } = updatedForm;
            updatedForm.identicalVol = calculateVolWeight(
                Number(identicalLenght),
                Number(identicalWidht),
                Number(identicalHeight)
            );
        }
        setIdenticalForm(updatedForm);
    };


    const handleIdenticalReset = () => {
        setIdenticalForm({
            "identicalLenght": '',
            "identicalWidht": '',
            "identicalHeight": '',
            "identicalVol": '',
            "identicalpieces": '',
        })
    }
    useEffect(() => {
        let totalVol = totalVolWgt.toString()
        setFormData({ ...formData, volumetricWeight: convertThreeDecimalsOnValue(totalVol) })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [totalVolWgt])

    useEffect(() => {
        setFormData({ ...formData, descTotalValue: convertThreeDecimalsOnValue(descTotalValue.toString()) })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [descTotalValue])

    useEffect(() => {
        if (Number(formData.actualWeight) > Number(formData.volumetricWeight)) {
            setFormData({ ...formData, chargedWeight: formData.actualWeight })
        } else {
            setFormData({ ...formData, chargedWeight: formData.volumetricWeight })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.actualWeight, formData.volumetricWeight])

    useEffect(() => {
        inputrefs.current['txtCustomerBillNo'].focus();
        document.title = 'Pick Up Request'
        HandleEditData(awbNo)
        setInvoicePrint(false)
    }, [])
    return (
        <>
            <div className='main-card PickUp_Entry card border-0'>
                <div className='card-header mb-1'>

                    <div className='d-flex align-items-center gap-2' style={{ marginTop: '-5px' }}>
                        <span className="fs-6 fw-bold headingspan " style={{ marginRight: "4px" }}> {menuText ? menuText : FindTranslatedKey('Pick Up Request')}</span>
                        {/*<input*/}

                        {/*    className='form-check-input'*/}
                        {/*    type='checkbox'*/}
                        {/*    id='txtautoAwbNo'*/}
                        {/*    checked={formData.autoAwbNo}*/}
                        {/*    onChange={(e) => {*/}
                        {/*        let checkValue = e.target.checked;*/}
                        {/*        setFormData({ ...formData, autoAwbNo: checkValue })*/}
                        {/*    }}*/}
                        {/*/>*/}
                        {/*<label className='mt-1' htmlFor='txtautoAwbNo'>{FindTranslatedKey('Awb No')}</label>*/}
                    </div>
                </div>

                <div className='card-body px-3'>
                    <div className="rounded py-1 px-2 mb-2 " style={{ boxShadow: 'rgba(101, 155, 242, 0.5) 0px 0px 5px', borderTop: "2px solid #f18282" }} >
                        <div className='row'>
                            <InputBox
                                label='Pick Up Ref No'
                                PlaceHolderText='Pick Up Ref No'
                                required={true}
                                inputrefs={inputrefs}
                                divclassname='col-md-3'
                                disabled={true}
                                id='txtRefNo'
                                value={formData.awbNo}
                                maxLength='10'
                                onChange={(e) => {
                                    setFormData({ ...formData, awbNo: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtCustomerBillNo'].focus();
                                    }
                                }}
                            />

                            <InputBox
                                label='Invoice No'
                                PlaceHolderText='Invoice No'
                                required={true}
                                inputrefs={inputrefs}
                                divclassname='col-md-3'
                                id='txtCustomerBillNo'
                                value={formData.custReferenceNo}
                                maxLength='100'
                                onChange={(e) => {
                                    setFormData({ ...formData, custReferenceNo: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtReferenceNo'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Reference No '
                                PlaceHolderText='Reference No '

                                inputrefs={inputrefs}
                                divclassname='col-md-3'

                                id='txtReferenceNo'
                                value={formData.referenceNumber}
                                maxLength='10'
                                onChange={(e) => {
                                    setFormData({ ...formData, referenceNumber: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtBookingDate'].focus();
                                    }
                                }}
                            />
                            <DateBox
                                inputrefs={inputrefs}
                                label="Booking Date"
                                placeholder="Booking Date"
                                divclassname='col-md-3'
                                id='txtBookingDate'
                                //  value={formData.shipmentDate ? formData.shipmentDate : ''}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtClient'].focus()
                                    };
                                }}
                                required={true}
                                selected={formData.shipmentDate === '' ? '' : new Date(formData.shipmentDate)}
                                onChange={(e) => handleDateChange(e, setFormData, formData, 'shipmentDate')}
                            />

                            <AutoCompleteBox
                                label='Client'
                                placeholder='Client'
                                inputValue={formData.cCode}
                                divclassname='col-md-3'
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                                onInputChange={
                                    (event, newInputValue) => {
                                        // handleAutoCompleteChange(event, newInputValue, '', 'GetClient');
                                        // setFormData({ ...formData, cCode: newInputValue })
                                        handleAutoCompleteChange(event, newInputValue, bcode, 'GetClient');
                                        setFormData({ ...formData, cCode: newInputValue })
                                    }
                                }
                                inputrefs={inputrefs}
                                id='txtClient'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                        e.preventDefault()
                                        inputrefs.current['txtConsignor'].focus()
                                    };
                                }}
                                required={true}
                            />
                            {Hidesfield ? <>
                                <AutoCompleteBox
                                    label='Branch'
                                    placeholder='Branch'
                                    inputValue={formData.branchCode}
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, '', 'GetBranch');
                                            setFormData({ ...formData, branchCode: newInputValue })
                                        }
                                    }
                                    inputrefs={inputrefs}
                                    id='txtBranch'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsignor'].focus()
                                        };
                                    }}
                                    required={true}
                                />
                            </> : <>

                            </>}


                            <div
                                className={`col-md-3  mb-1`}
                                ref={ref => (inputrefs.current['txtUploadInvoice'] = ref)}  >
                                <label className="form-label">{FindTranslatedKey('Upload Invoice')} </label>
                                <FileUploader
                                    classes='file-uploader'
                                    label='Upload'
                                    handleChange={(file) => {
                                        if (file.size > (2048 * 1024)) {
                                            setTimeout(() => {
                                                NotificationSound('ERROR', 'File should be less than or equal to 2 MB!')
                                            }, 0);
                                        } else {
                                            let extArr = (file.name).split(".");
                                            if (file) {
                                                const reader = new FileReader();
                                                reader.readAsDataURL(file);
                                                reader.onload = () => {
                                                    let logo = (reader.result).split(',')[1]
                                                    setFormData({
                                                        ...formData,
                                                        imagebase64: logo,
                                                        imageExt: extArr[1],
                                                        imageName: extArr[0]
                                                    });
                                                };
                                            }
                                        }
                                    }}
                                    name="file" types={["JPG", "PNG", "PDF"]}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current[''].focus()
                                        };
                                    }}
                                    children={<FileUploadChild label='' message={`${formData.imageName}`} types={[`${FindTranslatedKey('JPG')}`, `${FindTranslatedKey('PNG')}`, `${FindTranslatedKey('PDF')}`]} />}
                                />
                            </div>
                            {formData?.imageExt ? <>
                                <div className='col-md-1 mt-3 pointereye ' onClick={() => handleOpen()} style={{ backgroundColor: "#C2D7F8", width: "auto", height: "30px", borderRadius: "10px" }} title='View Invoice'>
                                    <FaRegEye className='mt-2 cursor-pointer' />
                                </div>
                            </> : <></>}


                        </div>
                    </div>
                    <div className='main-items-2 gap-1 d-flex my-2' >
                        <div className='items-2 rounded' style={{ borderTop: '2px solid var(--first_theme)' }}>
                            <div className='row  my-1 ' style={{ marginTop: '2px' }}>
                                <div className="col-lg-4 col-md-5 col-sm-12 pb-2 pe-2 pb-2">
                                    <h6 className='mb-0' style={{ fontSize: '12px' }}> {FindTranslatedKey('Consignor / Shipper')}</h6>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-5  pe-2">
                                    <div className='d-flex align-items-center gap-2' style={{ marginTop: '-5px' }}>
                                        <input
                                            className='form-check-input'
                                            type='checkbox'
                                            ref={ref => (inputrefs.current['txtConsignorAddressBook'] = ref)}
                                            id='txtConsignorAddressBook'
                                            checked={formData.consignorAddressBook}
                                            onChange={(e) => {
                                                let checkValue = e.target.checked;
                                                setFormData({ ...formData, consignorAddressBook: checkValue })
                                            }}
                                        />
                                        <label className='mt-1' htmlFor='txtConsignorAddressBook'> {FindTranslatedKey('Save to Address Book')}</label>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>

                                <AutoCompleteBox
                                    divclassname='col-sm-4 mb-1'
                                    label='Consignor / Shipper'
                                    placeholder='Consignor / Shipper'
                                    inputValue={formData.consignorName}
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    required={true}
                                    maxLength='100'
                                    onInputChange={(event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, formData.cCode, 'GetConsignor');
                                        setFormData({ ...formData, consignorName: newInputValue });
                                    }}
                                    onChange={(e, newInputValue) => {
                                        if (!newInputValue || newInputValue.trim() === '') {
                                            setFormData({
                                                ...formData,
                                                consignorName: '',
                                                consignorAddress1: '',
                                                consignorAddress2: '',
                                                consignorCityCode: '',
                                                consignorStateCode: '',
                                                consignorCountryCode: '',
                                                consignorZipCode: '',
                                                consignorPhoneNo: '',
                                                consignorEmailID: '',
                                                consignorGSTIN: '',
                                            });
                                        } else {
                                            getconsignordataResquet(newInputValue);
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    id='txtConsignor'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault();
                                            inputrefs.current['txtConsignorEmailID'].focus();
                                        }
                                    }}
                                />

                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    id='txtConsignorEmailID'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsignorPhoneNo'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='Email ID'
                                    required={true}
                                    PlaceHolderText='Email ID'
                                    value={formData.consignorEmailID}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consignorEmailID: e.target.value })
                                    }}
                                    maxLength='100'
                                />
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    id='txtConsignorPhoneNo'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsignorCountryCode'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='Phone No'
                                    required={true}
                                    PlaceHolderText='Phone No'
                                    value={formData.consignorPhoneNo}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consignorPhoneNo: e.target.value })
                                    }}
                                    maxLength='50'
                                />
                                <AutoCompleteBox
                                    divclassname='col-sm-4 mb-1'
                                    label='Country'
                                    placeholder='Country'
                                    required={true}
                                    inputValue={formData.consignorCountryCode}
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, '', 'GetCountry');
                                            setFormData({ ...formData, consignorCountryCode: newInputValue, consignorStateCode: "", consignorCityCode: "" })
                                        }
                                    }
                                    inputrefs={inputrefs}
                                    id='txtConsignorCountryCode'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsignorStateCode'].focus()
                                        };
                                    }}
                                    maxLength='50'
                                />
                                <AutoCompleteBox
                                    divclassname='col-sm-4 mb-1'
                                    label='State'
                                    placeholder='State'
                                    inputValue={formData.consignorStateCode}
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, formData.consignorCountryCode, 'GetState_CountryWise');
                                            setFormData({ ...formData, consignorStateCode: newInputValue })
                                        }
                                    }
                                    inputrefs={inputrefs}
                                    id='txtConsignorStateCode'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsignorCityCode'].focus()
                                        };
                                    }}
                                    //required={true}
                                    maxLength='50'
                                />
                                <AutoCompleteBox
                                    divclassname='col-sm-4 mb-1'
                                    label='City'
                                    placeholder='City'
                                    inputValue={formData.consignorCityCode}
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, formData.consignorCountryCode, 'GetCity_CountryWise');
                                            setFormData({ ...formData, consignorCityCode: newInputValue })
                                        }
                                    }
                                    inputrefs={inputrefs}
                                    id='txtConsignorCityCode'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsignorZip'].focus()
                                        };
                                    }}
                                    // required={true}
                                    maxLength='50'
                                />
                                <AutoCompleteBox
                                    divclassname='col-sm-4 mb-1'
                                    label='Zip'
                                    placeholder='Zip'
                                    inputValue={formData.consignorZipCode ? formData.consignorZipCode : ''}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, formData.consignorCityCode, 'GetPinCode_CityWise');
                                            setFormData({ ...formData, consignorZipCode: newInputValue })
                                        }}
                                    maxLength='6'
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    inputrefs={inputrefs}
                                    id='txtConsignorZip'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['txtConsignorAddress1'].focus() };
                                    }}
                                />
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    id='txtConsignorAddress1'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsignorAddress2'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='Address 1'
                                    required={true}
                                    PlaceHolderText='Address 1'
                                    value={formData.consignorAddress1}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consignorAddress1: e.target.value })
                                    }}
                                    maxLength='200'
                                />
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    id='txtConsignorAddress2'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsignorAddress3'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='Address 2'
                                    PlaceHolderText='Address 2'
                                    value={formData.consignorAddress2}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consignorAddress2: e.target.value })
                                    }}
                                    maxLength='200'
                                />
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    id='txtConsignorAddress3'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsignorGSTIN'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='Address 3'
                                    PlaceHolderText='Address 3'
                                    value={formData.consignorAddress3}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consignorAddress3: e.target.value })
                                    }}
                                    maxLength='200'
                                />
                                {/*<InputBox*/}
                                {/*    divclassname='col-sm-4 mb-1'*/}
                                {/*    inputclassname='p-1 form-control'*/}
                                {/*    id='txtConsignorZip'*/}
                                {/*    onKeyDown={(e) => {*/}
                                {/*        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {*/}
                                {/*            e.preventDefault()*/}
                                {/*            inputrefs.current['txtConsignorGSTIN'].focus()*/}
                                {/*        };*/}
                                {/*    }}*/}
                                {/*    inputrefs={inputrefs}*/}
                                {/*    label='Zip'*/}
                                {/*    placeholder='Zip'*/}
                                {/*    value={formData.consignorZipCode}*/}
                                {/*    onChange={(e) => {*/}
                                {/*        setFormData({ ...formData, consignorZipCode: e.target.value })*/}
                                {/*    }}*/}
                                {/*    maxLength='100'*/}
                                {/*/>*/}
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    inputclassname='p-1 form-control'
                                    id='txtConsignorGSTIN'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsignee'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='GSTIN'
                                    PlaceHolderText='GSTIN'
                                    maxLength='15'
                                    value={formData.consignorGSTIN}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consignorGSTIN: e.target.value })
                                    }}
                                />
                            </div>
                        </div>
                        <div className='items-2 rounded' style={{ borderTop: '2px solid var(--first_theme)' }}>
                            <div className='row my-1' style={{ marginTop: '2px' }}>
                                <div className="col-lg-4 col-md-5 col-sm-12 pb-2 pe-2 pb-2">
                                    <h6 className='mb-0' style={{ fontSize: '12px' }}>{FindTranslatedKey('Consignee/Receiver')} </h6>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-5  pe-2">
                                    <div className='d-flex align-items-center gap-2' style={{ marginTop: '-5px' }}>
                                        <input
                                            className='form-check-input'
                                            type='checkbox'
                                            ref={ref => (inputrefs.current['txtConsigneeAddressBook'] = ref)}
                                            id='txtConsigneeAddressBook'
                                            checked={formData.consigneeAddressBook}
                                            onChange={(e) => {
                                                let checkValue = e.target.checked;
                                                setFormData({ ...formData, consigneeAddressBook: checkValue })
                                            }}
                                        />
                                        <label className='mt-1' htmlFor='txtConsigneeAddressBook'>{FindTranslatedKey('Save to Address Book')} </label>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>

                                <AutoCompleteBox
                                    divclassname='col-sm-4 mb-1'
                                    label='Consignee/Receiver'
                                    placeholder='Consignee/Receiver'
                                    required={true}
                                    inputValue={formData.consigneeName}
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    onInputChange={(event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, formData.cCode, 'GetConsignee');
                                        setFormData({ ...formData, consigneeName: newInputValue });
                                    }}
                                    onChange={(e, newInputValue) => {
                                        if (!newInputValue || newInputValue.trim() === '') {

                                            setFormData({
                                                ...formData,
                                                consigneeName: '',
                                                consigneeAddress1: '',
                                                consigneeAddress2: '',
                                                consigneeCityCode: '',
                                                consigneeStateCode: '',
                                                consigneeCountryCode: '',
                                                consigneeZipCode: '',
                                                consigneePhoneNo: '',
                                                consigneeEmailID: '',
                                                consigneeGSTIN: '',
                                            });
                                        } else {
                                            getConsigneedataResquet(newInputValue);
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    id='txtConsignee'
                                    maxLength='100'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault();
                                            inputrefs.current['txtConsigneeEmailID'].focus();
                                        }
                                    }}
                                />
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    id='txtConsigneeEmailID'
                                    required={true}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsigneePhoneNo'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='Email ID'
                                    PlaceHolderText='Email ID'
                                    value={formData.consigneeEmailID}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consigneeEmailID: e.target.value })
                                    }}
                                    maxLength='100'
                                />
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    id='txtConsigneePhoneNo'
                                    required={true}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsigneeCountry'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='Phone No'
                                    PlaceHolderText='Phone No'
                                    value={formData.consigneePhoneNo}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consigneePhoneNo: e.target.value })
                                    }}
                                    maxLength='50'
                                />
                                <AutoCompleteBox
                                    divclassname='col-sm-4 mb-1'
                                    label='Country'
                                    placeholder='Country'
                                    inputValue={formData.consigneeCountryCode}
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, '', 'GetCountry');
                                            setFormData({ ...formData, consigneeCountryCode: newInputValue, consigneeStateCode: "", consigneeCityCode: "" })
                                        }
                                    }
                                    inputrefs={inputrefs}
                                    id='txtConsigneeCountry'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsigneeState'].focus()
                                        };
                                    }}
                                    required={true}
                                    maxLength='50'
                                />
                                <AutoCompleteBox
                                    divclassname='col-sm-4 mb-1'
                                    label='State'
                                    placeholder='State'
                                    inputValue={formData.consigneeStateCode}
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, formData.consigneeCountryCode, 'GetState_CountryWise');
                                            setFormData({ ...formData, consigneeStateCode: newInputValue })
                                        }
                                    }
                                    inputrefs={inputrefs}
                                    id='txtConsigneeState'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsigneeCity'].focus()
                                        };
                                    }}
                                    //required={true}
                                    maxLength='50'
                                />
                                <AutoCompleteBox
                                    divclassname='col-sm-4 mb-1'
                                    label='City'
                                    placeholder='City'
                                    inputValue={formData.consigneeCityCode}
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, formData.consigneeCountryCode, 'GetCity_CountryWise');
                                            setFormData({ ...formData, consigneeCityCode: newInputValue })
                                        }
                                    }
                                    inputrefs={inputrefs}
                                    id='txtConsigneeCity'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsigneeZipCode'].focus()
                                        };
                                    }}
                                    //required={true}
                                    maxLength='50'
                                />
                                <AutoCompleteBox
                                    divclassname='col-sm-4 mb-1'
                                    label='Zip'
                                    placeholder='Zip'
                                    inputValue={formData.consigneeZipCode ? formData.consigneeZipCode : ''}
                                    onInputChange={
                                        (event, newInputValue) => {
                                            handleAutoCompleteChange(event, newInputValue, formData.consigneeCityCode, 'GetPinCode_CityWise');
                                            setFormData({ ...formData, consigneeZipCode: newInputValue })
                                        }}
                                    maxLength='6'
                                    options={autoCompleteOptions}
                                    setOptions={setAutoCompleteOptions}
                                    inputrefs={inputrefs}
                                    id='txtConsigneeZipCode'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['txtConsigneeAddress1'].focus() };
                                    }}
                                />
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    id='txtConsigneeAddress1'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsigneeAddress2'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='Address 1'
                                    required={true}
                                    PlaceHolderText='Address 1'
                                    value={formData.consigneeAddress1}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consigneeAddress1: e.target.value })
                                    }}
                                    maxLength='200'
                                />
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    id='txtConsigneeAddress2'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsigneeAddress3'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='Address 2'
                                    PlaceHolderText='Address 2'
                                    value={formData.consigneeAddress2}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consigneeAddress2: e.target.value })
                                    }}
                                    maxLength='200'
                                />
                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    id='txtConsigneeAddress3'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtConsigneeGSTIN'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='Address 3'
                                    PlaceHolderText='Address 3'
                                    value={formData.consigneeAddress3}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consigneeAddress3: e.target.value })
                                    }}
                                    maxLength='200'
                                />

                                <InputBox
                                    divclassname='col-sm-4 mb-1'
                                    inputclassname='p-1 form-control'
                                    id='txtConsigneeGSTIN'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault()
                                            inputrefs.current['txtVolumetric'].focus()
                                        };
                                    }}
                                    inputrefs={inputrefs}
                                    label='GSTIN'
                                    PlaceHolderText='GSTIN'
                                    maxLength='15'
                                    value={formData.consigneeGSTIN}
                                    onChange={(e) => {
                                        setFormData({ ...formData, consigneeGSTIN: e.target.value })
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="rounded-bottom py-1 px-2 mb-2 " style={{ boxShadow: 'rgba(101, 155, 242, 0.5) 0px 0px 5px', borderTop: "2px solid #ff5b5c" }} >
                        <div className='mb-1 d-flex package-card  gap-1'>
                            <div className=" pe-4"><h6 className='mb-0'> {FindTranslatedKey('Weight Details')}</h6></div>
                            <div className='d-flex gap-2 CN' style={{ marginTop: '-5px' }}>
                                <input
                                    className='form-check-input'
                                    type='checkbox'
                                    ref={ref => (inputrefs.current['txtVolumetric'] = ref)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                            e.preventDefault();
                                            inputrefs.current['txtPieces'].focus()
                                        };
                                    }}
                                    id='txtVolumetric'
                                    checked={formData.volumetric}

                                    onChange={(e) => {
                                        let checkValue = e.target.checked;

                                        setFormData({ ...formData, volumetric: checkValue, });

                                    }}
                                />
                                <label className='mt-1' htmlFor='txtVolumetric'> {FindTranslatedKey('Identical')}</label>
                                {formData.volumetric === true ? <>  <IoAddCircleSharp className='mt-1 pointereye' style={{ color: "#78A8FE" }} onClick={() => handleOpenIdentical()} /></> : <></>}

                            </div>
                        </div>
                        <div className='row'>
                            <InputBox
                                label='Pieces'
                                PlaceHolderText='Pieces'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtPieces'
                                value={formData.totalPacket}
                                maxLength='10'
                                onChange={handleNewArrayAddonChange}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtTotalValue'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Total value'
                                PlaceHolderText='Total Value'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtTotalValue'
                                divclassname='col-md-2'
                                value={formData.totalValue}
                                maxLength='8'
                                onChange={(e) => {
                                    setFormData({ ...formData, totalValue: convertTwoDecimalsOnValue(e.target.value) })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtCurrency'].focus();
                                    }
                                }}
                            />
                            <SelectInputBox
                                required={true}
                                label='Currency'
                                inputrefs={inputrefs}
                                id='txtCurrency'
                                value={formData.currencyName}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtActualWeight'].focus();
                                    }
                                }}
                                onChange={async (e) => {
                                    setFormData({ ...formData, currencyName: e.target.value })
                                }}
                            >
                                <option value=''>{`--${FindTranslatedKey('Select')}--`}</option>
                                {GetCurrency?.data?.dataList?.map((item, index) =>
                                    <option key={item.name + index} value={item.name}>{FindTranslatedKey(item.name)}</option>
                                )}
                            </SelectInputBox>
                            <InputBox
                                label='Actual Weight'
                                PlaceHolderText='Actual Weight'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtActualWeight'
                                value={formData.actualWeight}
                                maxLength='100'
                                onChange={(e) => {
                                    setFormData({ ...formData, actualWeight: convertThreeDecimalsOnValue(e.target.value) })

                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtWeightUnit'].focus();
                                    }
                                }}
                            />
                            <SelectInputBox
                                label='Weight Unit'
                                placeholder='Weight Unit'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtWeightUnit'
                                value={formData.weightUnit}
                                onChange={(e) => {
                                    setFormData({ ...formData, weightUnit: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        formData.volumetric ?
                                            inputrefs.current['txtLength1'].focus() :
                                            inputrefs.current['txtPacketType'].focus();
                                    }
                                }}
                            >
                                <option value=''>{`--${FindTranslatedKey('Select')}--`}</option>
                                {GetWeightUnit?.data?.dataList?.map((item, index) =>
                                    <option key={item.name + index} value={item.name}>{FindTranslatedKey(item.name)}</option>
                                )}
                            </SelectInputBox>
                        </div>

                        {Number(formData.totalPacket) >= 1 &&
                            <div className='mt-2'>
                                <div className=' card mb-2 border-0' >
                                    <div className='card-header p-0' >
                                        <div className='card-body' style={{ padding: '0px' }}>
                                            <div className="table-responsive">
                                                <table className="table border mb-0">
                                                    <thead>
                                                        <tr className='light-bg'>
                                                            <th style={{ padding: '5px 4px', width: "0rem" }}> {FindTranslatedKey('Del')}</th>
                                                            <th style={{ padding: '5px 5px' }}> {FindTranslatedKey('Length')}  <span style={{ color: "red" }}> *</span></th>
                                                            <th style={{ padding: '5px 5px' }}> {FindTranslatedKey('Width')}  <span style={{ color: "red" }}> *</span></th>
                                                            <th style={{ padding: '5px 5px' }}>{FindTranslatedKey('Height')}  <span style={{ color: "red" }}> *</span></th>
                                                            <th style={{ padding: '5px 5px' }}>{FindTranslatedKey('Volume Wgt')} </th>
                                                            {/*<th style={{ padding: '5px 5px', width: "0rem" }}>Add</th>*/}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {formData?.weightDetails?.map((item, index) =>
                                                            <tr key={`packageDetailsList${index + 1}`} className="TableTrhover" >

                                                                <td className='' style={{ minWidth: "10px" }} >
                                                                    {<span style={{ marginLeft: "-2px" }} >
                                                                        <i className="fa-regular fa-trash-can text-danger me-3 text-center "
                                                                            onClick={() => handleDelete(index)}
                                                                            style={{ marginLeft: "0px", marginTop: "4px", paddingRight: "0px" }}
                                                                        />
                                                                    </span>}
                                                                </td>
                                                                <td className='p-1'>
                                                                    <input

                                                                        placeholder={FindTranslatedKey('Length')}
                                                                        className='form-control w-100 '
                                                                        value={item.length}
                                                                        maxLength='10'
                                                                        ref={ref => (inputrefs.current[`txtLength${index + 1}`] = ref)}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                                                e.preventDefault();
                                                                                inputrefs.current[`txtWidth${index + 1}`].focus()
                                                                            };
                                                                        }}
                                                                        onChange={(e) => {
                                                                            let length = e.target.value;
                                                                            let breadth = Number(item.breadth)
                                                                            let height = Number(item.height)
                                                                            let volWgt = (Number(length) * breadth * height) / Number(formData.divisor);
                                                                            volWgt = (volWgt).toString()
                                                                            let list = [...formData.weightDetails];
                                                                            list[index] = { ...list[index], length: convertThreeDecimalsOnValue(length), volWeight: volWgt ? convertThreeDecimalsOnValue(volWgt) : '' }
                                                                            setFormData({ ...formData, weightDetails: list });
                                                                        }}
                                                                        onFocus={(e) => e.target.select()}
                                                                    />
                                                                </td>
                                                                <td className='p-1'>
                                                                    <input
                                                                        className='form-control w-100 '
                                                                        value={item.breadth}

                                                                        placeholder={FindTranslatedKey('Width')}
                                                                        maxLength='10'
                                                                        ref={ref => (inputrefs.current[`txtWidth${index + 1}`] = ref)}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                                                e.preventDefault();
                                                                                inputrefs.current[`txtHeight${index + 1}`].focus()
                                                                            };
                                                                        }}
                                                                        onChange={(e) => {
                                                                            let breadth = e.target.value;
                                                                            let length = Number(item.length)
                                                                            let height = Number(item.height)
                                                                            let volWgt = (Number(length) * breadth * height) / Number(formData.divisor)
                                                                            volWgt = (volWgt).toString()
                                                                            let list = [...formData.weightDetails];
                                                                            list[index] = { ...list[index], breadth: convertThreeDecimalsOnValue(breadth), volWeight: volWgt ? convertThreeDecimalsOnValue(volWgt) : '' }
                                                                            setFormData({ ...formData, weightDetails: list });
                                                                        }}
                                                                        onFocus={(e) => e.target.select()}
                                                                    />
                                                                </td>
                                                                <td className='p-1'>
                                                                    <input
                                                                        className='form-control w-100 '
                                                                        value={item.height}
                                                                        maxLength='10'
                                                                        placeholder={FindTranslatedKey('Height')}
                                                                        ref={ref => (inputrefs.current[`txtHeight${index + 1}`] = ref)}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                                                e.preventDefault();
                                                                                const nextIndex = index + 1;
                                                                                if (formData.weightDetails[nextIndex]) {
                                                                                    inputrefs.current[`txtLength${nextIndex + 1}`].focus();
                                                                                }
                                                                                else {
                                                                                    inputrefs.current['txtPacketType'].focus();
                                                                                }
                                                                            }
                                                                        }}
                                                                        onChange={(e) => {
                                                                            let height = e.target.value;
                                                                            let length = Number(item.length)
                                                                            let breadth = Number(item.breadth)
                                                                            let volWgt = (Number(length) * breadth * height) / Number(formData.divisor)
                                                                            volWgt = (volWgt).toString()
                                                                            let list = [...formData.weightDetails];
                                                                            list[index] = { ...list[index], height: convertThreeDecimalsOnValue(height), volWeight: volWgt ? convertThreeDecimalsOnValue(volWgt) : '' }
                                                                            setFormData({ ...formData, weightDetails: list });
                                                                        }}
                                                                        onFocus={(e) => e.target.select()}
                                                                    />
                                                                </td>
                                                                <td className='p-1'>
                                                                    <input
                                                                        className='form-control w-100 '
                                                                        value={item.volWeight}
                                                                        maxLength='10'
                                                                        placeholder={`${FindTranslatedKey('Volume Wgt')}.`}
                                                                        ref={ref => (inputrefs.current[`txtVolWeight${index + 1}`] = ref)}
                                                                        disabled
                                                                    />
                                                                </td>
                                                                {/*<td className='p-1'>*/}
                                                                {/*    {formData.weightDetails.length - 1 === index && < span >*/}
                                                                {/*        <i className="fa-solid fa-circle-plus mt-1 text-success me-2"*/}
                                                                {/*            onClick={() => handleAdd(index)}*/}
                                                                {/*        />*/}
                                                                {/*    </span>}*/}
                                                                {/*</td>*/}
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className='row'>
                            <InputBox
                                label='Total Weight'
                                PlaceHolderText='Total Weight'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtTotalWeight'
                                value={formData.actualWeight}
                                maxLength='15'
                                disabled={true}
                            />
                            <InputBox
                                label='Total Volumetric Weight'
                                PlaceHolderText='Total Volumetric Weight'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtTotalWeight'
                                value={formData.volumetricWeight}
                                maxLength='15'
                                disabled={true}
                            />
                            <InputBox
                                label='Total Charge Weight'
                                PlaceHolderText='Total Charge Weight'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtTotalWeight'
                                value={formData.chargedWeight}
                                maxLength='15'
                                disabled={true}
                            />

                            {Hidesfield ? <>
                                <InputBox
                                    label='Rate/Kg'
                                    PlaceHolderText='Rate/Kg'
                                    required={true}
                                    inputrefs={inputrefs}
                                    id='txtRatePerKg'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtPacketType'].focus();
                                        }
                                    }}
                                    value={formData.perKGRate}
                                    onChange={(e) => setFormData({ ...formData, perKGRate: convertTwoDecimalsOnValue(e.target.value) })}
                                    maxLength='20'
                                />
                            </> : <>

                            </>}


                        </div>
                    </div>
                    <div className='mb-2 main_card border-0'>
                        <div className='package-card other_details' >
                            <div className='grn-card-item' style={{ borderColor: '#0d8d0d' }}>
                                <div className='w-100 d-flex'>
                                    <h6 className='mb-0 mt-1'>{FindTranslatedKey('Packet Details')}</h6>
                                </div>
                                <div className='row other_cn_details mt-1'>
                                    <SelectInputBox
                                        label='Packet Type'
                                        required={true}
                                        inputrefs={inputrefs}
                                        id='txtPacketType'
                                        value={formData.packetType}
                                        onChange={(e) => {
                                            setFormData({ ...formData, packetType: e.target.value })
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtPaymentType'].focus();
                                            }
                                        }}
                                    >
                                        <option value=''>{`--${FindTranslatedKey('Select')}--`}</option>
                                        {GetPacketType?.data?.dataList?.map((item, index) =>
                                            <option key={item.name + index} value={item.name}>{FindTranslatedKey(item.name)}</option>
                                        )}
                                    </SelectInputBox>

                                    <SelectInputBox
                                        label='Payment Type'
                                        required={true}
                                        inputrefs={inputrefs}
                                        id='txtPaymentType'
                                        value={formData.paymentType}
                                        onChange={(e) => {
                                            setFormData({ ...formData, paymentType: e.target.value, codAmount: '', codCurrency: '' })
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                (formData.paymentType === 'COD' || formData.paymentType === 'CASH') ?
                                                    inputrefs.current['txtCODAmount'].focus() :
                                                    inputrefs.current['txtDescription1'].focus();
                                            }
                                        }}
                                    >
                                        <option value=''>{`--${FindTranslatedKey('Select')}--`}</option>
                                        {GetPaymentType?.data?.dataList?.map((item, index) =>
                                            <option key={item.name + index} value={item.name}>{FindTranslatedKey(item.name)}</option>
                                        )}
                                    </SelectInputBox>
                                    {(formData.paymentType === 'COD') && <>
                                        <InputBox
                                            label='COD Amount'
                                            PlaceHolderText='COD Amount'
                                            required={true}
                                            inputrefs={inputrefs}
                                            id='txtCODAmount'
                                            value={formData.codAmount}
                                            maxLength='10'
                                            onChange={(e) => {
                                                setFormData({ ...formData, codAmount: convertTwoDecimalsOnValue(e.target.value) })
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    inputrefs.current['txtCODCurrency'].focus();
                                                }
                                            }}
                                        />

                                        <SelectInputBox
                                            label='COD Currency'
                                            required={true}
                                            inputrefs={inputrefs}
                                            id='txtCODCurrency'
                                            value={formData.codCurrency}
                                            onChange={(e) => {
                                                setFormData({ ...formData, codCurrency: e.target.value })
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    inputrefs.current['txtDescription1'].focus();
                                                }
                                            }}
                                        >
                                            <option value=''>{`--${FindTranslatedKey('Select')}--`}</option>
                                            {GetCurrency?.data?.dataList?.map((item, index) =>
                                                <option key={item.name + index} value={item.name}>{item.name}</option>
                                            )}
                                        </SelectInputBox>
                                    </>
                                    }
                                    <InputBox
                                        label='Desc Total Value'
                                        PlaceHolderText='Desc Total Value'
                                        inputrefs={inputrefs}
                                        id='txtDescTotalValue'
                                        value={formData.descTotalValue}
                                        disabled={true}
                                    />
                                </div>
                                <div className='mt-2'>
                                    <div className=' card mb-2 border-0' >
                                        <div className='card-header p-0' >
                                            <div className='card-body' style={{ padding: '0px' }}>
                                                <div className="table-responsive">
                                                    <table className="table border mb-0">
                                                        <thead>
                                                            <tr className='light-bg'>
                                                                <th style={{ padding: '5px 4px', width: "0rem" }}>{FindTranslatedKey('Del')}</th>
                                                                <th style={{ padding: '5px 5px' }}>{FindTranslatedKey('Description')} <span style={{ color: "red" }}> *</span></th>
                                                                <th style={{ padding: '5px 5px' }}>{FindTranslatedKey('HSNo')}</th>
                                                                <th style={{ padding: '5px 5px' }}>{FindTranslatedKey('UQC')}</th>
                                                                <th style={{ padding: '5px 5px' }}>{FindTranslatedKey('Quantity')} <span style={{ color: "red" }}> *</span></th>
                                                                <th style={{ padding: '5px 5px' }}>{FindTranslatedKey('Unit Value')} <span style={{ color: "red" }}> *</span></th>
                                                                <th style={{ padding: '5px 5px' }}>{FindTranslatedKey('Total')} <span style={{ color: "red" }}> *</span></th>
                                                                <th style={{ padding: '5px 5px', width: "0rem" }}> {FindTranslatedKey('Add')}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {formData?.descriptionDetail?.map((item, index) =>
                                                                <tr key={`packageDetailsList${index + 1}`} className="TableTrhover" >
                                                                    <td className='' style={{ minWidth: "10px" }} >
                                                                        {<span style={{ marginLeft: "-2px" }} >
                                                                            <i className="fa-regular fa-trash-can text-danger me-3 text-center "
                                                                                onClick={() => handleDeleteDesc(index)}
                                                                                style={{ marginLeft: "0px", marginTop: "4px", paddingRight: "0px" }}
                                                                            />
                                                                        </span>}
                                                                    </td>
                                                                    <td className='p-1'>
                                                                        <input
                                                                            placeholder={FindTranslatedKey('Description')}
                                                                            className='form-control w-100'
                                                                            value={item.description}
                                                                            maxLength='150'
                                                                            ref={ref => (inputrefs.current[`txtDescription${index + 1}`] = ref)}
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                                                    e.preventDefault(); inputrefs.current[`txtHSNo${index + 1}`].focus()
                                                                                };
                                                                            }}
                                                                            onChange={(e) => {
                                                                                let decs = e.target.value
                                                                                let list = [...formData.descriptionDetail];
                                                                                list[index] = { ...list[index], description: decs }
                                                                                setFormData({ ...formData, descriptionDetail: list });
                                                                            }}
                                                                            onFocus={(e) => e.target.select()}
                                                                        />
                                                                    </td>
                                                                    <td className='p-1'>
                                                                        <input
                                                                            placeholder={FindTranslatedKey('HSNo')}
                                                                            className='form-control w-100'
                                                                            value={item.hsNo}
                                                                            maxLength='8'
                                                                            minLength='4'
                                                                            ref={ref => (inputrefs.current[`txtHSNo${index + 1}`] = ref)}
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                                                    e.preventDefault();
                                                                                    inputrefs.current[`txtUQC${index + 1}`].focus()
                                                                                };
                                                                            }}
                                                                            onChange={(e) => {
                                                                                let hsNo = e.target.value
                                                                                let list = [...formData.descriptionDetail];
                                                                                list[index] = { ...list[index], hsNo: hsNo }
                                                                                setFormData({ ...formData, descriptionDetail: list });
                                                                            }}
                                                                            onFocus={(e) => e.target.select()}
                                                                        />
                                                                    </td>
                                                                    <td className='p-1'>
                                                                        <select
                                                                            placeholder={FindTranslatedKey('UQC')}
                                                                            className='form-select w-100 '
                                                                            value={item.uniqueQuantity}
                                                                            ref={ref => (inputrefs.current[`txtUQC${index + 1}`] = ref)}
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                                                    e.preventDefault();
                                                                                    inputrefs.current[`txtUnit${index + 1}`].focus()
                                                                                };
                                                                            }}
                                                                            onChange={(e) => {
                                                                                let uqc = e.target.value
                                                                                let list = [...formData.descriptionDetail];
                                                                                list[index] = { ...list[index], uniqueQuantity: uqc }
                                                                                setFormData({ ...formData, descriptionDetail: list });
                                                                            }}

                                                                        >
                                                                            <option value=''>{`--${FindTranslatedKey('Select')}--`}</option>
                                                                            {GetQUCType?.data?.dataList?.map((item, index) =>
                                                                                <option key={item.name + index} value={item.name}>{FindTranslatedKey(item.name)}</option>
                                                                            )}

                                                                        </select>
                                                                    </td>
                                                                    <td className='p-1'>
                                                                        <input
                                                                            className='form-control w-100 '
                                                                            value={item.units}
                                                                            placeholder={FindTranslatedKey('Quantity')}
                                                                            maxLength='10'
                                                                            ref={ref => (inputrefs.current[`txtUnit${index + 1}`] = ref)}
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                                                    e.preventDefault();
                                                                                    inputrefs.current[`txtUnitValue${index + 1}`].focus()
                                                                                };
                                                                            }}
                                                                            onChange={(e) => {
                                                                                let units = e.target.value;
                                                                                let unitValue = item.unitValue;
                                                                                let total = Number(units) * Number(unitValue)
                                                                                let list = [...formData.descriptionDetail];
                                                                                list[index] = {
                                                                                    ...list[index],
                                                                                    units: convertToNumber(units),
                                                                                    total: total.toString()
                                                                                }
                                                                                setFormData({ ...formData, descriptionDetail: list });
                                                                            }}
                                                                            onFocus={(e) => e.target.select()}
                                                                        />
                                                                    </td>
                                                                    <td className='p-1'>
                                                                        <input
                                                                            className='form-control w-100 '
                                                                            value={item.unitValue}
                                                                            maxLength='10'
                                                                            placeholder={FindTranslatedKey('Unit Value')}
                                                                            ref={ref => (inputrefs.current[`txtUnitValue${index + 1}`] = ref)}
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                                                    e.preventDefault();
                                                                                    const nextIndex = index + 1;
                                                                                    if (formData.descriptionDetail[nextIndex]) {
                                                                                        inputrefs.current[`txtDescription${nextIndex + 1}`].focus();
                                                                                    }
                                                                                    else {
                                                                                        inputrefs.current[`btnSave`].focus()
                                                                                    }
                                                                                }
                                                                            }}
                                                                            onChange={(e) => {
                                                                                let unitValue = e.target.value;
                                                                                let units = item.units;
                                                                                let total = Number(units) * Number(unitValue)
                                                                                let list = [...formData.descriptionDetail];
                                                                                list[index] = {
                                                                                    ...list[index],
                                                                                    unitValue: convertThreeDecimalsOnValue(unitValue),
                                                                                    total: total.toString()
                                                                                }
                                                                                setFormData({ ...formData, descriptionDetail: list });
                                                                            }}
                                                                            onFocus={(e) => e.target.select()}
                                                                        />
                                                                    </td>
                                                                    <td className='p-1'>
                                                                        <input
                                                                            className='form-control w-100 '
                                                                            value={item.total}
                                                                            maxLength='10'
                                                                            placeholder={FindTranslatedKey('Total')}
                                                                            ref={ref => (inputrefs.current[`txtTotal${index + 1}`] = ref)}
                                                                            id={`txtTotal${index + 1}`}
                                                                            disabled
                                                                        />
                                                                    </td>
                                                                    <td className='p-1'>
                                                                        {formData.descriptionDetail.length - 1 === index && < span >
                                                                            <i className="fa-solid fa-circle-plus mt-1 text-success me-2"
                                                                                onClick={() => handleAddDesc(index)}
                                                                            />
                                                                        </span>}
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <FormButton
                            id='btnSave'
                            inputrefs={inputrefs}
                            handleSubmit={handleSubmit}
                            Export={false}
                            handleClear={handleClear}
                            Print={invoicePrint}
                            handlePrint={handlePrint}
                        />
                    </div>
                </div>
            </div>
            < Modal
                show={incomeModalShow} onHide={handleModalShowClose}
                size="lg"

                keyboard={false}
                contentClassName='modaldashboard'

            >
                <Modal.Header closeButton >
                    <Modal.Title >

                        <h4> {FindTranslatedKey('Upload Invoice View')}</h4>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='col-md-3 mt-3 row' style={{ width: "auto", position: "relative" }}>
                        {formData.imagebase64 && formData.imageExt !== 'pdf' ? (
                            <img
                                className='border border-success img-thumbnail'
                                src={`data:image/${formData.imageExt};base64,${formData.imagebase64}`}
                                alt='logo'
                                style={{ width: '100%', height: '500px', border: 'none' }}
                            />
                        ) : formData.imagebase64 && formData.imageExt === 'pdf' ? (
                            <iframe
                                title="PDF Preview"
                                src={generatePdfUrl(formData.imagebase64)}
                                style={{ width: '100%', height: '500px', border: 'none' }}
                            />
                        ) : null}
                    </div>
                </Modal.Body>
                <Modal.Footer>

                </Modal.Footer>
            </Modal >

            < Modal
                show={identicalShow} onHide={handleModalIdenticalShowClose}
                size="lg"

                keyboard={false}
                contentClassName='modaldashboard'

            >
                <Modal.Header closeButton >
                    <Modal.Title >
                        {FindTranslatedKey(' Weight Details')}

                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <InputBox
                            divclassname='col-md-2 col-sm-6'
                            label='Length'
                            PlaceHolderText='Length'
                            labelclass='mt-1'
                            inputrefs={inputrefs}
                            id='txtIdenticalLenght'
                            value={identicalForm.identicalLenght}
                            maxLength='10'
                            onChange={(e) => handleChangeIdentical('identicalLenght', convertThreeDecimalsOnValue(e.target.value))}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtIdenticalWidth'].focus();
                                }
                            }}
                        />
                        <InputBox
                            divclassname='col-md-2 col-sm-6'
                            label='Width'
                            labelclass='mt-1'
                            PlaceHolderText='Width'
                            inputrefs={inputrefs}
                            id='txtIdenticalWidth'
                            value={identicalForm.identicalWidht}
                            maxLength='10'
                            onChange={(e) => handleChangeIdentical('identicalWidht', convertThreeDecimalsOnValue(e.target.value))}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtIdenticalHeight'].focus();
                                }
                            }}
                        />
                        <InputBox
                            divclassname='col-md-2 col-sm-6'
                            label='Height'
                            PlaceHolderText='Height'
                            labelclass='mt-1'
                            inputrefs={inputrefs}
                            id='txtIdenticalHeight'
                            value={identicalForm.identicalHeight}
                            maxLength='10'
                            onChange={(e) => handleChangeIdentical('identicalHeight', convertThreeDecimalsOnValue(e.target.value))}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtidenticalpieces'].focus();
                                }
                            }}
                        />
                        <InputBox
                            divclassname='col-md-2 col-sm-6'
                            label='Vol Weight'
                            PlaceHolderText='Vol Weight'
                            labelclass='mt-1'
                            inputrefs={inputrefs}
                            id='txtIdenticalVolWeight'
                            disabled
                            value={identicalForm.identicalVol}
                            maxLength='50'
                            onChange={(e) => handleChangeIdentical('identicalVol', e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtidenticalpieces'].focus();
                                }
                            }}
                        />
                        <InputBox
                            divclassname='col-md-2 col-sm-6'
                            label='No. of PKG'
                            PlaceHolderText='No. of PKG'
                            labelclass='mt-1'
                            inputrefs={inputrefs}
                            id='txtidenticalpieces'
                            value={identicalForm.identicalpieces}
                            maxLength='10'
                            onChange={(e) => handleChangeIdentical('identicalpieces', e.target.value)}

                        />

                        <div className='col-md-2 col-sm-6 d-flex gap-1 align-items-center mt-4'>
                            <RiAddBoxFill style={{ fontSize: "30px", color: "green", cursor: "pointer" }} onClick={handleIdentical} />
                            <GrPowerReset style={{ fontSize: "28px", color: "red", cursor: "pointer" }} onClick={handleIdenticalReset} />
                        </div>


                    </div>
                </Modal.Body>
                <Modal.Footer>

                </Modal.Footer>
            </Modal >
        </>
    )
}
export default PickUpRequest;